import request from '@/utils/request'

//
export function index(data){
	return request({
    url: '/api/index/index',
    method: 'POST',
    data: data || {}
  })
}